import React, { useState, useEffect } from 'react';
import { getUserState, httpPost } from '../utils';

import Success from '../Success/Success';

const AzureADSuccess = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(true);
    useEffect(() => {
        if (window.location.search) {
            const search = window.location.search.substring(1);
            const data = JSON.parse(
                '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
            );

            getUserState().then(async () => {
                try {
                    const response = await httpPost('/Settings/aadAccessTokenResponse', data);
                    if (!response.data || !response.data.result) {
                        setIsSuccess(false);
                    }
                } catch (err) {
                    console.log(err);
                    setIsSuccess(false);
                } finally {
                    setIsLoading(false);
                }
            });
        }
    }, []);

    return <Success isLoading={isLoading} isSuccess={isSuccess} />;
};

export default AzureADSuccess;
